import React from "react";
import { useParams } from "react-router-dom";
import { FeatureTemplate } from "../../components/marketing/FeatureTemplate";
import ReputationManagementPage from "./ReputationManagementPage";
import { FEATURES_BY_SLUG } from "../../data/featuresData";
import NotFound from "../NotFound";

export default function FeaturePage() {
  const { slug } = useParams();
  const data = FEATURES_BY_SLUG[slug];
  if (!data) return <NotFound />;
  if (slug === "reputation-management") return <ReputationManagementPage />;
  return <FeatureTemplate data={data} />;
}
